import { BackgroundImage, createStyles, Paper, Text } from '@mantine/core'
import React, { ReactElement } from 'react'

import { TMapTile } from '../../types'

type TItemProps = {
  maptile: TMapTile
  isSelected: boolean
  onSelect: (name: string) => void
}

const useStyle = createStyles(
  (theme, { isSelected }: { isSelected: boolean }) => ({
    root: {
      height: '100px',
      cursor: 'pointer',
      borderWidth: '0.0625rem',
      borderStyle: 'solid',
      borderColor: isSelected ? theme.colors.blue[5] : theme.colors.gray[2],
      '&:hover': {
        borderColor: isSelected ? theme.colors.blue[3] : theme.colors.gray[5],
      },
      // borderRadius: theme.radius.md,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.7)',
    },
    // image: {
    //   ...theme.fn.cover(),
    //   ref: getStylesRef('image'),
    //   backgroundSize: 'cover',
    //   transition: 'transform 500ms ease',
    // },
    background: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
    },
    textWrapper: {
      // display: 'flex',
      // textAlign: 'center',
      // // height: '100%',
      // justifyContent: 'center',
      // alignItems: 'center',
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      // border: '2px solid lime',
    },
    text: {
      // color: 'white',
      // mixBlendMode: 'difference',
      textShadow: '0 0 5px white',
      textAlign: 'center',
      backgroundColor: 'rgba(255,255,255,0.75)',
      // boxShadow: '0 0 15px 10px rgba(255,255,255,0.6)',
      padding: '0 10px',
      borderBottomLeftRadius: theme.radius.sm,
      borderBottomRightRadius: theme.radius.sm,
      color: theme.colors.gray[9],
    },
  }),
)

export const Item = (props: TItemProps): ReactElement => {
  const { maptile, isSelected, onSelect } = props

  const { classes } = useStyle({ isSelected })

  const onClick = (): void => {
    onSelect(maptile.name)
  }

  return (
    <>
      <Paper
        className={classes.root}
        shadow="sm"
        radius="sm"
        // withBorder
        onClick={onClick}
      >
        {/* <div className={classes.overlay} /> */}
        <BackgroundImage
          src={maptile.url.replace('{z}/{x}/{y}', '4/8/5')}
          radius="sm"
          className={classes.background}
          style={{ backgroundPositionY: '130px', display: 'flex' }}
        >
          <div className={classes.textWrapper}>
            <Text className={classes.text} size="sm">
              {maptile.label}
            </Text>
          </div>
        </BackgroundImage>
      </Paper>
    </>
  )
}
